(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8313],{

/***/ 51530:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/press",
      function () {
        return __webpack_require__(19453);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 46636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(84595);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5121);










var InPress = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState([]), 2), pressPosts = ref[0], setPressPosts = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(), 2), hubtpotPressFields = ref1[0], setHubtpotPressFields = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var fetchData = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                var data, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                axios__WEBPACK_IMPORTED_MODULE_8__/* ["default"].get */ .Z.get("/api/press/common-press")
                            ];
                        case 1:
                            data = _state.sent().data;
                            setPressPosts(data);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData().catch(console.error);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var fetchHubSpotPromotionBanner = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                var data, error;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                axios__WEBPACK_IMPORTED_MODULE_8__/* ["default"].get */ .Z.get("/api/hubspot-cms/press-cms")
                            ];
                        case 1:
                            data = _state.sent().data;
                            console.log("HubSpot banner data:", data);
                            setHubtpotPressFields(data.fieldPlaceholders);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            if (axios__WEBPACK_IMPORTED_MODULE_8__/* ["default"].isAxiosError */ .Z.isAxiosError(error)) {
                                console.error("Error fetching HubSpot banner:", error.message);
                            } else {
                                console.error("Error fetching HubSpot banner:", error);
                            }
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchHubSpotPromotionBanner() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchHubSpotPromotionBanner();
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "container py-30 bg-white",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "font-bold-h4 mb-10",
                children: hubtpotPressFields === null || hubtpotPressFields === void 0 ? void 0 : hubtpotPressFields.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().cardsWrapper),
                children: pressPosts && pressPosts.map(function(item) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().cardContainer)),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().cardLeft),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("py-3", (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().cardHeader)),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("font-regular-sm", (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().dateWrapper)),
                                            children: item === null || item === void 0 ? void 0 : item.date
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "font-bold-base mt-10 link",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            href: item === null || item === void 0 ? void 0 : item.link,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().textPrimary)),
                                                children: item === null || item === void 0 ? void 0 : item.title
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().cardRight),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().imgWrapper),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        unoptimized: true,
                                        src: item === null || item === void 0 ? void 0 : item.image,
                                        alt: "pressPost-logo",
                                        layout: "fill",
                                        objectFit: "contain"
                                    })
                                })
                            })
                        ]
                    }, item === null || item === void 0 ? void 0 : item.id);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InPress);


/***/ }),

/***/ 19453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_shared_SEO__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34853);
/* harmony import */ var _libs_resources__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41090);
/* harmony import */ var _components_shared_Press__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46636);





var Press = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_SEO__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: (0,_libs_resources__WEBPACK_IMPORTED_MODULE_3__/* .getText */ .Q)().InPress.SEO.title,
                description: (0,_libs_resources__WEBPACK_IMPORTED_MODULE_3__/* .getText */ .Q)().InPress.SEO.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_Press__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Press);


/***/ }),

/***/ 84595:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"styles_cardContainer__Y8t5q","cardsWrapper":"styles_cardsWrapper__t2iZ0","cardLeft":"styles_cardLeft__VibuL","cardRight":"styles_cardRight__kQdzy","imgWrapper":"styles_imgWrapper__aWJlV","dateWrapper":"styles_dateWrapper__yzWct","cardHeader":"styles_cardHeader__9kNQ4","listHeader":"styles_listHeader__3Coaq","description":"styles_description__GsfoP","footer":"styles_footer__QT59l","textPrimary":"styles_textPrimary__61NDy"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(51530); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);